var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"dropdown-tag-item",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('select', _vm.value)}}},[_c('a',{class:{ mark: _vm.mark, selected: _vm.selected },attrs:{"href":"#"}},[_c('span',{class:{ mark: _vm.mark, selected: _vm.selected }},[_vm._v(_vm._s(_vm.value.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }